// ============================================================
// FILE: resources/js/helpers/formatters.js
// USPATIH GO — Format Helpers (Rupiah, Tanggal, Time Ago)
// ============================================================

/**
 * Format angka ke Rupiah
 * @param {number} amount
 * @param {string} prefix
 * @returns {string}
 */
export function formatRupiah(amount, prefix = 'Rp ') {
  if (amount === null || amount === undefined) return prefix + '0';
  return prefix + Number(amount).toLocaleString('id-ID', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

/**
 * Format tanggal ke bahasa Indonesia
 * @param {string|Date} date
 * @param {object} options - Intl.DateTimeFormat options
 * @returns {string}
 */
export function formatDate(date, options = {}) {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('id-ID', {
    day: '2-digit', month: 'long', year: 'numeric', ...options,
  });
}

/**
 * Format "relative time" (e.g., "2 jam lalu")
 * @param {string|Date} date
 * @returns {string}
 */
export function timeAgo(date) {
  const now  = new Date();
  const then = new Date(date);
  const diff = Math.floor((now - then) / 1000);

  if (diff < 60)      return 'Baru saja';
  if (diff < 3600)    return `${Math.floor(diff / 60)} menit lalu`;
  if (diff < 86400)   return `${Math.floor(diff / 3600)} jam lalu`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)} hari lalu`;
  return formatDate(date);
}

// ---- Expose ke window agar bisa dipakai di Blade / Alpine ----
window.formatRupiah = formatRupiah;
window.formatDate   = formatDate;
window.timeAgo      = timeAgo;
